import $ from '../common/wrapper';
// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
  // NAVBAR SEARCH
  // -----------------------------------
  const navSearch = new navbarSearchInput();

  // Open search input
  const $searchOpen = $('[data-search-open]');

  $searchOpen
    .on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
    })
    .on('click', navSearch.toggle);

  // Close search input
  const $searchDismiss = $('[data-search-dismiss]');
  const inputSelector = '.navbar-form input[type="text"]';

  $(inputSelector)
    .on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
    })
    .on('keyup', function(e) {
      if (e.keyCode === 27)
        // ESC
        navSearch.dismiss();
    });

  // click anywhere closes the search
  $(document).on('click', navSearch.dismiss);
  // dismissable options
  $searchDismiss
    .on('click', function(e) {
      e.stopPropagation();
    })
    .on('click', navSearch.dismiss);

  function navbarSearchInput() {
    const navbarFormSelector = 'form.navbar-form';
    return {
      toggle: function() {
        const navbarForm = $(navbarFormSelector);

        navbarForm.toggleClass('open');

        const isOpen = navbarForm.hasClass('open');

        navbarForm.find('input')[isOpen ? 'focus' : 'blur']();
      },

      dismiss: function() {
        $(navbarFormSelector)
          .removeClass('open') // Close control
          .find('input[type="text"]')
          .blur(); // remove focus
        // .val('') // Empty input
      }
    };
  }
};
